module.exports = __webpack_public_path__ + "img/arm.cc1bc000.png";